import { Box, Group } from '@byecode/ui'
import type { EndConfig, FlowNode } from '@lighthouse/shared'
import { OUTPUT_SINGLE_DATA_NODES, useAtomData, WorkflowType } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { workflowListAtom } from '@/atoms/workflow/state'
import { useFlowContainerContext } from '@/contexts/FlowContext'
import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import { SettingOutputArg } from '../../SettingOutputArg'
import * as SC from '../styles'

interface EndConfigureProps {
    allParentNodes: FlowNode[]
    value?: EndConfig
    onChange: (value: EndConfig | undefined) => void
}

export const EndConfigure: React.FC<EndConfigureProps> = ({ allParentNodes, value, onChange }) => {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const dataSourceList = useDataSourceList(appId, envId)
    const workflowList = useAtomData(workflowListAtom)

    const upstreamNodes = useMemo(() => allParentNodes.filter(node => OUTPUT_SINGLE_DATA_NODES.has(node.data.nodeType)), [allParentNodes])

    return (
        <SC.Container>
            <Group label="输出变量">
                <Box px={8}>
                    <SettingOutputArg
                        value={value?.outputArgs}
                        workflowList={workflowList}
                        dataSourceList={dataSourceList}
                        upstreamNodes={upstreamNodes}
                        allParentNodes={allParentNodes}
                        onChange={next => onChange({ ...(value || ({})), outputArgs: next })}
                    />
                </Box>
            </Group>
        </SC.Container>
    )
}
